import React, { PureComponent, lazy, Suspense } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import i18next from 'i18next';
import debounce from 'lodash/debounce';
import GoalServices from '../services/goal.services';
import { reorderItem } from '../utils/function';
import OkrRow from './okr/common_okr_components/okrRow.component';
import { okrDetailActions } from '../actions/okr/okrDetails.actions';
import { okrDetailConstants } from '../constants/okr/okrDetails.constants';
import { directDotedActions } from '../actions/directDoted.actions';
import ShowOnlyKrs from './okr/okr_depend_components/showOnlyKrs.component';
import { getGoalsCount } from '../utils/common';
import {
  applyFilterDataSetToApiParams,
  buildFilterDataSet,
  getFilterParamsFromUrl,
  isTruthyOverdueParam,
  buildDirectDotedPreviewBackUrl,
  isDirectDotedDueStatusUrlHydration,
  isDirectDotedListPageType,
  resolveDirectDotedListDueStatus,
  urlHasOkrFilters,
  isUiFiltersAppliedInUrl,
  applyHideEmptyOkrsToApiParams,
  filterGoalKeyResultsByStatus,
  getOkrFilterCount,
} from '../utils/okrFilterParams.util';
import ImgIconComp from './imgcomp';
import OneLineAlignmentButtonComp from './oneLineAlignment/oneLineAlignmentButton' ;

const EmptyGoalContainer = lazy(() => import(
  /* webpackChunkName: "emptyGoalContainer" */
  './okr/okr_depend_components/emptyGoalContainer.component'
)); 
const ErrorDisplay = lazy(() => import(
  /* webpackChunkName: "errorDisplay" */
  './common/errorDisplay.component'
));
const LoaderComp = function (props) {
  return (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);
};
class OkrComp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mouseOverId: null,
      showGoalMetrics: null,
      activeButton: 'okrGaol',
      dueStatus: this.props.dueStatus || false,
      stateOffset:this.props.offset||0,
      teamsCount: 0,
      clickedAlready: false
    };
    this.GoalServices = new GoalServices();
    this.clickGoalRowCount = 0;
    this.clickGoalRowTimer = null;
    this.reloadOkr = this.reloadOkr.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.resetShowmetric = this.resetShowmetric.bind(this);
    this.GaolMetricCommentLists = React.createRef();
    this.delayCallback = debounce(this.handleScroll, 100);
    window.OkrComp = this;
    this.resetStateOffset = this.resetStateOffset.bind(this);
    this._initialMountComplete = false;
    this._suppressDueStatusFetch = false;
  }

  componentDidMount() {
    const { type, isReloadTab = false } = this.props;
    if(typeof this.props.params !== 'undefined' && typeof this.props.params.offset !== 'undefined'){
      this.props.params.offset = 0;
    }
    let param = {};
    if (typeof this.props.gs !== 'undefined' && this.props.gs == 1 && (type == okrDetailConstants.PAGE_TYPE_OKR_I_OWN 
      || type == okrDetailConstants.PAGE_TYPE_MY_TEAM_OKR || type == okrDetailConstants.PAGE_TYPE_MY_MANAGER_OKR)) {
      param.gs = 1;
    }
    const isMyKRPage = (type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE && isReloadTab);
    const isDirectDotedListTab = isDirectDotedListPageType(type);
    const isDirectOkrTab = type === okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR;
    const urlHasFilters = isDirectDotedListTab && urlHasOkrFilters();
    const urlDueStatus = isDirectDotedListTab && isTruthyOverdueParam(getFilterParamsFromUrl().overdueKR);
    if (urlDueStatus === true && this.props.dueStatus !== true) {
      this._suppressDueStatusFetch = true;
      this.props.dispatch({ type: okrDetailConstants.SYNC_OVERDUE_STATUS, dueStatus: true });
    }
    if (!(isDirectOkrTab && this.props.clientFilterApplied === true && this.props.teams?.length > 0)) {
      const useUiFiltersOnMount = urlHasFilters
        || this.props.clientFilterApplied === true
        || isUiFiltersAppliedInUrl();
      this.getDataFromUrlCall(param, isMyKRPage ? false : !isDirectOkrTab, {
        dueStatus: resolveDirectDotedListDueStatus({}, this.props, isDirectDotedListTab),
        appliedListFilters: useUiFiltersOnMount,
        clientFilterApplied: useUiFiltersOnMount,
        uiFiltersApplied: useUiFiltersOnMount,
      });
    } else {
      removeLoaderWidget();
    }
    this._initialMountComplete = true;
    this.callRequest = false;
    this._isMounted = true;
    document.body.addEventListener("click", this.closeObjectiveFilter);
    window.addEventListener('scroll', this.delayCallback, false);
  }

  componentWillReceiveProps(nextProps){
    if (this.state.dueStatus !== nextProps.dueStatus) {
      this.setState({
        dueStatus: nextProps.dueStatus
      });

      const isUrlHydration = this._suppressDueStatusFetch === true
        || (
          this.props.type === okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR
          && isDirectDotedDueStatusUrlHydration(
            this.state.dueStatus === true,
            nextProps.dueStatus === true,
          )
        );
      if (this._suppressDueStatusFetch === true) {
        this._suppressDueStatusFetch = false;
      }
      if (this._initialMountComplete === true && isUrlHydration !== true) {
        if (this.props.type === okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR) {
          const directDotedBackUrl = buildDirectDotedPreviewBackUrl(
            nextProps.filterDataSet,
            nextProps.dueStatus === true,
            {
              clientFilterApplied: nextProps.clientFilterApplied === true,
              filterCount: nextProps.count,
              activeTab: 1,
            },
          );
          window.history.replaceState({}, '', directDotedBackUrl);
          this.getDataFromUrlCall({}, false, { dueStatus: nextProps.dueStatus === true });
        } else if (this.props.type === okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR) {
          const directDotedBackUrl = buildDirectDotedPreviewBackUrl(
            nextProps.filterDataSet,
            nextProps.dueStatus === true,
            {
              clientFilterApplied: nextProps.clientFilterApplied === true,
              filterCount: nextProps.count,
              activeTab: 2,
            },
          );
          window.history.replaceState({}, '', directDotedBackUrl);
          this.getDataFromUrlCall({}, false, { dueStatus: nextProps.dueStatus === true });
        } else if (this.props.type === okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR) {
          this.getDataFromUrlCall(
            { overdueKR: nextProps.dueStatus === true },
            false,
            { dueStatus: nextProps.dueStatus === true },
          );
        }
      }
    }
    const teamsLength = (typeof nextProps.teams !== 'undefined') ? nextProps.teams.length : 0;
    this.setState({
      teamsCount: teamsLength
    })
  }

  resetParamsData =()=>{
    if(typeof this.props.params !== 'undefined' && this.props.params && typeof this.props.params.startDate !== 'undefined' && typeof this.props.params.endDate !== 'undefined'){
      this.props.params.startDate ="";
      this.props.params.endDate = "";
    }
  }
  
  getDataFromUrlCall = (param = {}, newCall = false, callOptions = {}) => {
    const { type, url, params={}, showOption, teamId, 
    userId, filterDataSet = {} } = this.props;
    const isDirectDotedListTab = isDirectDotedListPageType(type);
    const isDirectOkrTabForDue = isDirectDotedListTab;
    const dueStatus = resolveDirectDotedListDueStatus(
      callOptions,
      this.props,
      isDirectDotedListTab,
    );
    let newParams =  Object.assign(params,param);
    if (newCall){
      delete newParams.exDate;
      delete newParams.endDate;
      delete newParams.startDate;
      delete newParams.status;
      delete newParams.categories;
      delete newParams.performance;
    }
    const isKRUpdateFilter = (type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE 
      || type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH 
      || type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR);
    const isDirectOkrTab = type === okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR;
    let appliedListFilters = false;
    if (typeof filterDataSet !== 'undefined' && filterDataSet !== null && filterDataSet !== '' && !isKRUpdateFilter) {
      applyFilterDataSetToApiParams(newParams, filterDataSet, dueStatus);
      appliedListFilters = true;
    }
    if ((isDirectDotedListTab || type === okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR)
      && (urlHasOkrFilters() || isUiFiltersAppliedInUrl())) {
      applyFilterDataSetToApiParams(
        newParams,
        buildFilterDataSet(getFilterParamsFromUrl()),
        dueStatus,
      );
      appliedListFilters = true;
    }
    if (isKRUpdateFilter || !appliedListFilters) {
      delete newParams['gs'];
      newParams.status = '1';
    }
    if(typeof params.offset === 'undefined'){
      newParams.offset = this.props.offset;
    }
    
    if(typeof newParams.offset === 'undefined' || newParams.offset == 0 ){
      showLoaderWidget($("#content"));
    }else if(typeof newParams.offset !== 'undefined' || newParams.offset > 0){
      this.props.dispatch({type: okrDetailConstants.SHOW_PAGINATION_LOADER});
    }
    if (type == okrDetailConstants.PAGE_TYPE_OKR_I_OWN) {
      newParams.f = showOption;
      if(newParams.startDate == undefined) {

        delete newParams.status;

      }
      this.props.dispatch(okrDetailActions[url](newParams));
    }
    else if(type == okrDetailConstants.PAGE_TYPE_MY_MANAGER_OKR){
      if(newParams.startDate == undefined) {

        delete newParams.status;

      }
      this.props.dispatch(okrDetailActions[url](newParams));
    }
    else if(type == okrDetailConstants.PAGE_TYPE_MY_TEAM_OKR){
      if(newParams.startDate == undefined) {

        delete newParams.status;

      }
      this.props.dispatch(okrDetailActions[url](newParams));
    }
    else if (type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR) {
      if(typeof newParams.offset == 'undefined'){
        newParams.offset = 0;
      }
      if (dueStatus === true) {
        newParams.overdueKR = 1;
      } else {
        delete newParams.overdueKR;
      }
      const useUiFilters = appliedListFilters === true
        || this.props.clientFilterApplied === true
        || callOptions.uiFiltersApplied === true;
      if (useUiFilters === true) {
        newParams[okrDetailConstants.UI_FILTERS_APPLIED] = 1;
      } else {
        delete newParams[okrDetailConstants.UI_FILTERS_APPLIED];
      }
      if (newParams.startDate == undefined && !appliedListFilters) {
        delete newParams.status;
      }
      this.props.dispatch(directDotedActions.getDirectDotedOkrs(
        newParams,
        {
          dueStatus: dueStatus,
          clientFilterApplied: this.props.clientFilterApplied === true,
          appliedListFilters: appliedListFilters,
          uiFiltersApplied: useUiFilters === true,
        },
      ));
    }
    else if (type == okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR) {
      if (typeof newParams.offset !== 'undefined' || (typeof newParams.overdueKR !== 'undefined' || (param && typeof param.overdueKR !== 'undefined'))) {
        if (typeof teamId !== 'undefined' && teamId != '') {
          newParams.teamId = teamId;
        } else if (typeof userId !== 'undefined' && userId != '') {
          newParams.userId = userId;
        }
        newParams.jsonRes = true;
        if(typeof newParams.overdueKR == 'undefined' && dueStatus){
          newParams.overdueKR = dueStatus
        }
        if(typeof newParams.offset == 'undefined'){
          newParams.offset = 0;
        }
        if(typeof newParams.krTags != 'undefined'){
          var custom_id = '';
          newParams.krTags.map(tag => custom_id += tag.id + ',');
          custom_id = custom_id.substring(custom_id.length - 1, 0);
          delete newParams.krTags;
          newParams.custom_tag_id = custom_id;
        }
        if (window.location.href.includes('filterMap')) {
          newParams.filterMap = 1;
        }
        console.log("url",url);
        this.props.dispatch(okrDetailActions[url](newParams));
      } else {
        removeLoaderWidget();
      }
    }
    else if (type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR) {
      delete newParams.categories;
      delete newParams.f;
      newParams.kr_own_update = showOption;
      newParams.flag = 2;
      if(typeof newParams.offset == 'undefined'){
        newParams.offset = 0;
      }
      if (dueStatus === true) {
        newParams.overdueKR = 1;
      } else {
        delete newParams.overdueKR;
      }
      const useUiFilters = appliedListFilters === true
        || this.props.clientFilterApplied === true
        || callOptions.uiFiltersApplied === true;
      if (useUiFilters === true) {
        newParams[okrDetailConstants.UI_FILTERS_APPLIED] = 1;
      } else {
        delete newParams[okrDetailConstants.UI_FILTERS_APPLIED];
      }
      applyHideEmptyOkrsToApiParams(newParams, {
        clientFilterApplied: useUiFilters,
        dueStatus: dueStatus === true,
        appliedListFilters: appliedListFilters === true,
      });
      this.props.dispatch(okrDetailActions.getMyDirectsKR(newParams, {
        dueStatus: dueStatus === true,
        clientFilterApplied: useUiFilters,
        appliedListFilters: appliedListFilters === true,
        uiFiltersApplied: callOptions.uiFiltersApplied === true || useUiFilters,
        filterDataSet: appliedListFilters
          ? buildFilterDataSet(getFilterParamsFromUrl())
          : undefined,
        filterCount: appliedListFilters ? getOkrFilterCount(newParams) : undefined,
      }));
    }
    else if(type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH){
      delete newParams.categories;
      delete newParams.f;
      newParams.kr_own_update = showOption;
      newParams.id = this.props.teams.encryptID;
      newParams.json = true;
      newParams.flag = 3;
      if(newParams.overdueKR 
        || (typeof newParams.overdueKR !== 'undefined' && !newParams.overdueKR)
        || (typeof newParams.offset !== 'undefined' && newParams.offset > 0)){
          if (newParams.overdueKR) {
            newParams.overdueKR = true;
          }
          this.props.dispatch(okrDetailActions.getOverduePersonKrs(newParams));
      }
      else{
        removeLoaderWidget();
      }
    }
  }
  
  componentWillUnmount() {
    this.callRequest = false;
    this._isMounted = false;
    window.removeEventListener('scroll', this.delayCallback, false);
  }

  resetShowmetric() {
    this.setState({ showGoalMetrics: null });
  }

  fetchGoals = (goalId = null) => {
    const { dispatch, type, teams } = this.props;
    //dispatch(okrDetailActions.getMyGoals(params));
    if(type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_OKR){
      let data ={ goalId }
      dispatch({type:okrDetailConstants.DIRECT_DOTTED_OKR_DELETE_SUCCESS, data});
    }else {
      const rows = teams
        .map(row => {
          row.goals = row.goals.filter(goal => goal.id != goalId);
          return row;
        })
        .filter(r => r.goals.length);
        let data = {data: rows}
        dispatch({type:okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS, data});
    }
  }

  handleScroll = () => {
    let { activeButton } = this.state;
    var elementExists = document.querySelector('#goal_index_page');//           document.getElementById("");
    let typeClass = this.props.type.toLowerCase()+"_pagination" ;
    const typeElm = document.querySelector('.'+typeClass);
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    // if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) {
    // 	return;
    // }
    if (activeButton == 'okrGaol' && this._isMounted && windowBottom >= (docHeight - 700) && elementExists && typeElm) { // check you're at the bottom of the page			
      this.fetchingMoreData();
    }
  }

  fetchingMoreData = () => {
    if (!window.ObjectiveFilter) {
      return;
    }
    let { pagination, paginationLimit, type } = this.props;
    let offsetValue = 0;
    
    // Assign filters from the filter box as the scroll fetches more data
    let goalFilterProps = window.ObjectiveFilter.returnFilterParam();
    let params = goalFilterProps.filterDataSet || {};
    const scrollDueStatus = goalFilterProps.dueStatus ?? this.props.dueStatus;
    if (scrollDueStatus === true || params.overdueKR) {
      params.overdueKR = 1;
    }

    if(type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR || type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE || type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH){
            offsetValue = getGoalsCount(this.props.teams.metrics, type);
            params.kr_own_update = this.props.showOption;
        }else{
            offsetValue = getGoalsCount(this.props.teams, type);
    }
    let { activeButton ,stateOffset} = this.state;
    
    if (pagination && activeButton == 'okrGaol' && offsetValue >= paginationLimit && (offsetValue % paginationLimit >= 0) &&  stateOffset != offsetValue) {
      
      params.offset = offsetValue;
      if (this.props.type == okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR) {
        if (typeof this.props.teamId !== 'undefined' && this.props.teamId !== "") {
          params.teamId = this.props.teamId;
        } else if (typeof this.props.userId !== 'undefined' && this.props.userId !== "") {
          params.userId = this.props.userId;
        }
      }
      this.setState({
        stateOffset:offsetValue
      }, () => {
        this.getDataFromUrlCall(params);
      })
    }
  }

  handleShortCutBar = (goalId) =>{
    this.props.dispatch(okrDetailActions.saveShortCutPreference(goalId));
  }

  clickedAlreadyFn = () => {
    this.setState({ 
      clickedAlready:!this.state.clickedAlready 
    })
  }

  resetStateOffset(){
    this.setState({
      stateOffset: 0
    });
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const teamId = result.destination.droppableId.split('_')[1];
    let items = [];
    const rows = this.props.teams.map((row) => {
      if (row.team_id == teamId) {
        row.goals = reorderItem(row.goals, result.source.index, result.destination.index);
        items = row.goals.map(goal => goal.id);
      }
      return row;
    });

    let data = { data: rows }
    this.props.dispatch({ type: okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS, data });
    if (this.props.type === okrDetailConstants.PAGE_TYPE_TEAM_TAB_OKR) {
      this.GoalServices.saveTeamGoalOrder({ items, id: teamId });
    } else {
      this.GoalServices.saveGoalOrder({ items, id: teamId });
    }
  }

  //need to test it once everyone integrated
  reloadOkr(e, loadMetricComment = false) {
    if (loadMetricComment && loadMetricComment == this.state.showGoalMetrics) {
      if (typeof this.GaolMetricCommentLists !== 'undefined' && this.GaolMetricCommentLists !== null) {
        this.GaolMetricCommentLists.viewMetricComments({}, loadMetricComment);
      }
      // $(document).trigger('metric_comments_reload_comp', [loadMetricComment]);
    }
  }

  renderOKR(goal, userData, showGoalMetrics, dragHandleProps = null) {
    const { filterDataSet, type } = this.props;
    return (
        <OkrRow
          key={`renderokr_${goal.id}`}
          goal={filterGoalKeyResultsByStatus(goal, filterDataSet, type)}
          showGoalMetrics={showGoalMetrics}
          userData={userData}
          refComp={ref => this.GaolMetricCommentLists = ref}
          progressType={this.props.progressType}
          displayKrConfidence={this.props.displayKrConfidence}
          displayKrClustering={this.props.displayKrClustering}
          okrDependency={goal.dependency_count}
          okrAlignment={goal.alignment_count}
          onRefetchGoals={this.fetchGoals}
          showGoalMetricList={this.props.showGoalMetric}
          showGoalName={this.props.showGoalName}
          showRealOwner = {this.props.showRealOwner}
          showSourceName={this.props.showSourceName}
          type={this.props.type}
          showShortCutBar={this.props.showShortCutBar}
          showOkrDependencyAlignment={this.props.showOkrDependencyAlignment}
          emojisData={this.props.emojisData}
          handleShortCutBar={this.handleShortCutBar}
          clickedAlready={this.state.clickedAlready}
          cbClickedAlready={this.clickedAlreadyFn}
          addNewKrAction = {(item, teamId) => this.props.dispatch(okrDetailActions.addNewKr(item, teamId))}
          deleteKrAction = {(id, goalId, teamId, userId) => this.props.dispatch(okrDetailActions.deleteKr(id,goalId, teamId, userId))}
          {...(dragHandleProps && { dragHandleProps })}
          notificationsData={this.props.notificationsData}
        />		
    );
  }

  renderKRRows = (teams, userData, showGoalMetrics, createCascadeEmailEn) => {
    return (
      <ShowOnlyKrs
        teams={teams}
        userData={userData}
        showGoalMetrics={showGoalMetrics}
        showUserName={this.props.showUserName}
        showTeamName={this.props.showTeamName}
        showSourceName={this.props.showSourceName}
        showRealOwner = {this.props.showRealOwner}
        cascadedData={this.props.teams.cascadeList}
        type={this.props.type}
        emojisData={this.props.emojisData}
        createCascadeEmailEn={createCascadeEmailEn}
        displayKrConfidence={this.props.displayKrConfidence}
        fullAlignData={this.props.fullAlignData}
        // startDate={this.startDate}
        // endDate={this.endDate}
        exDate={this.props.exDate}
        status={this.props.goalStatus}
        dispatch={this.props.dispatch}
        addNewKrAction = {(item, teamId) => this.props.dispatch(okrDetailActions.addNewKr(item, teamId))}
        deleteKrAction = {(id, goalId, teamId, userId) => this.props.dispatch(okrDetailActions.deleteKr(id,goalId, teamId, userId))}
      />
    )
  }

  renderOkrGroup(group, sorting, userData, showGoalMetrics, index) {
    sorting = sorting && group.goals.length > 1 && !group.goals.find(goal => goal.id == showGoalMetrics);
    let idForAlignment = "";
    if(typeof group.team_id !== 'undefined' && group.team_id != '' && group.team_id != 0){
			idForAlignment += "team-" + group.team_id;
		}
    else if (typeof group.team_id !== 'undefined' && group.team_id == 0 
      && typeof userData.id !== 'undefined' && userData.id) {
        idForAlignment = "personal-user-" + userData.id;
    }
    else if(typeof this.props.userId !== 'undefined' && this.props.userId != ''){
			idForAlignment = "user-" + this.props.userId;
		}
    const { type } = this.props;
    const isShowAlignmentButton = (type === okrDetailConstants.PAGE_TYPE_OKR_I_OWN 
      || type === okrDetailConstants.PAGE_TYPE_KR_I_UPDATE 
      || type === okrDetailConstants.PAGE_TYPE_MY_MANAGER_OKR 
      || type === okrDetailConstants.PAGE_TYPE_MY_TEAM_OKR
    );
    if (sorting) {
      return (
        <DragDropContext
          onDragEnd={this.onDragEnd}
          key={`group_${group.team_id}`}
        >
          <Droppable
            droppableId={`group_${group.team_id}`}
            isDropDisabled={false}
          >
            {(provided, snapshot) => (
              <div
                className="okr-group-sub-wrapper"
                key={`group_team_id_${group.team_id}`}
              >
                {/* <div className="okr-group-header"> */}
                  <div
                    role="heading"
                    aria-level="3"
                    data-testid="okr-group-name"
                    className={`okr-group-name ${
                      group.team_id == -1 ? 'no-associated-team' : ''
                    }`}
                    style={{display: 'flex', alignItems:'center'}}
                  >
                    {this.props.showTeamName && group.name}
                    {
                    (this.props.type === okrDetailConstants.PAGE_TYPE_OKR_I_OWN 
                    || this.props.type === okrDetailConstants.PAGE_TYPE_MY_MANAGER_OKR || this.props.type === okrDetailConstants.PAGE_TYPE_MY_TEAM_OKR) &&
                      <OneLineAlignmentButtonComp
                        dispatch = {this.props.dispatch}
                        fullAlignData = {this.props.fullAlignData}
                        sid = {idForAlignment}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                        exDate={this.props.exDate}
                        status={this.props.goalStatus}
                        loadSlideronMount={index === 0 && this.props.idForAlignment ? this.props.idForAlignment : null}
                        style={{marginTop: 0, marginLeft: 15}}
                      />
                    }
                  </div>
                 
                {/* </div> */}
               
                <div className="clear" />
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {group.goals.map((goal, index) => (
                    <Draggable
                      key={`draggable_${goal.id}`}
                      draggableId={goal.id}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          key={`draggable_div_${goal.id}`}
                        >
                          {this.renderOKR(goal, userData, showGoalMetrics, provided.dragHandleProps)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      );
    }

    return (
      <div className="okr-group-sub-wrapper" key={group.team_id}>
      {
        this.props.showTeamName && (
        <div role="heading" aria-level="3" data-testid="okr-group-name" className="okr-group-name" style={{display: 'flex', alignItems:'center'}}>
          {
              group.name
          }
          {
            isShowAlignmentButton &&
              <OneLineAlignmentButtonComp
                dispatch = {this.props.dispatch}
                fullAlignData = {this.props.fullAlignData}
                sid = {idForAlignment}
                startDate={this.props.startDate}
                endDate={this.props.endDate}
                exDate={this.props.exDate}
                status={this.props.goalStatus}
                loadSlideronMount={index === 0 && this.props.idForAlignment ? this.props.idForAlignment : null}
                style={{marginTop: 0, marginLeft: 15}}
              />
          }
        </div>)
      }
        <div className="clear" />
        {
          group.goals.map(goal => this.renderOKR(goal, userData, showGoalMetrics))
        }
      </div>
    );
  }

  renderRows() {
    const { sorting = false, teams, showUserName, type,createCascadeEmail } = this.props;
    const { showGoalMetrics = null } = this.state;
    const { userData = {} } = this.props;
    let onlyKrPages = [okrDetailConstants.PAGE_TYPE_KR_I_UPDATE, okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH, okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR];
    let createCascadeEmailEn = createCascadeEmail != null ? createCascadeEmail : false ;
    if (teams) {
      if (onlyKrPages.includes(type)) {
        return (
          <div className="okr-group-wrapper stretchedCol2">
            {
              ((typeof teams.metrics != 'undefined' && teams.metrics && teams.metrics.length > 0) || 
                (typeof teams.cascadeList !== 'undefined' && teams.cascadeList && Object.keys(teams.cascadeList).length > 0))  && 
                  this.renderKRRows(teams, userData, showGoalMetrics, createCascadeEmailEn)}
          </div>
        )
      }

      if (!showUserName) {
        return (
          <div className="okr-group-wrapper">
            {teams.map((group, index) => this.renderOkrGroup(group, sorting, userData, showGoalMetrics, index))}
          </div>
        )
      } else {
        return (
          <div className="okr-group-wrapper">
            {teams.map(group => this.renderUserDataRows(group, sorting, userData, showGoalMetrics))}
          </div>
        )
      }
    }
  }
  clickProfile = (userId) => {
        var url = wbConfig.baseUrl + '/memberProfile/index?id=' + userId;
        window.open(url, "_blank");
    }

  renderUserDataRows(group, sorting, userData, showGoalMetrics) {
    let teamsData = { "teams": group.teams };
    return (
      <>
        <div user_id={group.user_id} className="okr-user-block">
          <div className="okr-user-img" ><img src={group.picture} onClick={(e) => this.clickProfile(group.user_id)}/></div>
          <div className="okr-user-name">{group.name}</div>
          <div className="okr-user-break"></div>
        </div>
        {
          teamsData.teams.map(grp => this.renderOkrGroup(grp, sorting, userData, showGoalMetrics))
        }
      </>
    )
  }

	render() {	
    let {
      disableHeatmap, teams, type
    } = this.props;
    let onlyKrPages = [okrDetailConstants.PAGE_TYPE_KR_I_UPDATE, okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH, okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR];
    const emptyGoalPromoProps = { disableHeatmap };
    return (
      <>
        {!this.props.loading ? (
          <div>
            {
              typeof teams !== 'undefined' && teams && Object.keys(teams).length > 0 && typeof teams.metrics === 'undefined' && this.renderRows()
            }
            {
              (typeof teams === 'undefined' || (teams && Object.keys(teams).length == 0) && !(this.props.filterFlag || this.props.dueStatus)) && type != 'PAGE_TYPE_TEAM_TAB_OKR' &&
                <Suspense fallback={null}>
                  <EmptyGoalContainer {...emptyGoalPromoProps} key="empty_goal_container" />
                </Suspense>
            }
            {
              (typeof teams === 'undefined' || (teams && Object.keys(teams).length == 0) && !(this.props.filterFlag || this.props.dueStatus)) && type == 'PAGE_TYPE_TEAM_TAB_OKR' &&
              <Suspense fallback={null}>
                <ErrorDisplay errorText={`${i18next.t('No current open OKRs.')} ${i18next.t('You can filter to see closed OKRs')}`}/>
              </Suspense>
            }
            {
              onlyKrPages.includes(type)
              && typeof teams !== 'undefined' &&
              ((typeof teams.metrics != 'undefined' && teams.metrics && teams.metrics.length > 0) || 
              (typeof teams.cascadeList !== 'undefined' && teams.cascadeList && Object.keys(teams.cascadeList).length > 0))  && 
              this.renderRows()
            }
            {
              typeof teams !== 'undefined' && teams && Object.keys(teams).length == 0 && (this.props.filterFlag || this.props.dueStatus) && (
                <Suspense fallback={null}>
                  <ErrorDisplay
                    errorText={`${i18next.t('No OKRs fit the filter criteria.')}`}
                  />
                </Suspense>
              )
            }
            {
              (type == okrDetailConstants.PAGE_TYPE_PERSON_KR_SEARCH || type == okrDetailConstants.PAGE_TYPE_MY_DIRECT_KR  || type == okrDetailConstants.PAGE_TYPE_KR_I_UPDATE) 
              && typeof teams !== 'undefined' &&
              typeof teams !== 'undefined' && teams && ( !teams.metrics || teams.metrics.length == 0 ) && (
                <Suspense fallback={null}>
                  <ErrorDisplay
                    errorText={`${i18next.t('No KRs fit the search criteria.')}`}
                  />
                </Suspense>
              )
            }
          </div>
        ) : (
            ""
          )}

          {
            this.props.showLoader ? <LoaderComp /> : ""
          }
      </>
    );
  }
}

OkrComp.defaultProps = {
  rows: [],
  sortingClass: '',
  data: {},
  isGroupOkr: false,
  sorting: false,
};

function mapStateToProps(state) {
  console.log("STATE")
  console.log(state);
  return {
    ...state.okrDetailsReducer,
    ...state.CommentsReducers
  };
}
const OkrCompHOC = OkrComp

export default connect(mapStateToProps, null, null, { forwardRef: true })(OkrCompHOC);
